import React from "react";
import Translator from "Languages/Utility/Translator";
import * as Icons from 'react-bootstrap-icons';

export default function FinancialType(cell) {
  return (
    <div className={`saaf_${cell}`}>
      {
        {
          'Sale' : <Icons.Bag size={15} />,
          'Credit' : <Icons.Wallet2 size={15} />,
        }[cell]
      }
      {" "}
      <Translator id={`saaf_${cell}`} />
    </div>
  );
}
